module.exports = __webpack_public_path__ + "media/images/autopilot_preview-email_sms-m-9e54d7b3c5c7b71a428bd5be76d6337a.svg";